import { Grid } from "@mui/material";
import { useState } from "react";
import BranchManagementMain from "./BranchManagementMain";
import BranchSettings from "./BranchSettings";
import ClinicBranches from "./ClinicBranches";

const ClinicBranchManagement = () => {
  const [selectedTab, setSelectedTab] = useState("Branches");

  return (
    <BranchManagementMain active="clinicBranchManagement">
      <Grid container className="ph2">
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="back-white p10 bs-margin mh20"
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row">
                <div
                  className="ph10pv3"
                  onClick={() => setSelectedTab("Branches")}
                >
                  <div
                    className={`flex-center cursor ${
                      selectedTab === "Branches"
                        ? "pet-det-sel-tab"
                        : "pet-det-un-sel-tab"
                    }`}
                  >
                    Branches
                  </div>
                </div>
                {/* <div
                  className="ph10pv3"
                  onClick={() => setSelectedTab("Settings")}
                >
                  <div
                    className={`flex-center cursor ${
                      selectedTab === "Settings"
                        ? "pet-det-sel-tab"
                        : "pet-det-un-sel-tab"
                    }`}
                  >
                    Settings
                  </div>
                </div> */}
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {selectedTab === "Branches" ? <ClinicBranches /> : <BranchSettings />}
    </BranchManagementMain>
  );
};

export default ClinicBranchManagement;
